import { useAuth } from '../contexts/AuthContext';

export { useAuth };
export default useAuth;
